/* Gruppo Quinta Strada · lo store su Shopify: lo stesso store.js del sito statico (sito/assets/js/store.js), con le
   parti vive di Shopify al posto di quelle finte: il carrello è quello vero (/cart.js, /cart/add.js, /cart/change.js) e
   «Vai alla cassa» porta al checkout; la ricerca usa la ricerca di Shopify (/search?…&view=qs-json); la scheda
   sceglie la variante (taglia e, dove c'è, colore). Filtri, righe degli ultimi arrivi, galleria: come sul sito statico.
   Nessun numero di capi da nessuna parte (Domenico, 12/10/2026). Generato in tema da strumenti/genera-tema.py. */
(function () {
  "use strict";
  var doc = document, win = window, body = doc.body;
  var calma = win.matchMedia("(prefers-reduced-motion: reduce)");
  var computer = win.matchMedia("(min-width: 1001px)");
  var ROOT = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || "/";
  var JSON_H = { "Content-Type": "application/json", "Accept": "application/json" };

  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function euro(n) {
    var s = (Math.round(Number(n) * 100) / 100).toFixed(2).split(".");
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + s[1] + " €";
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;" }[c];
    });
  }
  function piatto(s) { return String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase(); }
  /* lo stesso «slug» per i valori dei filtri, da Liquid (handleize) e dagli indirizzi del sito (genera-store.py) */
  function norm(s) { return piatto(s).replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); }
  function testo(sel) { var el = $(sel); return el ? el.textContent.trim() : ""; }

  /* ── la card di un capo (la stessa di snippets/qs-card.liquid), per i risultati della ricerca ── */
  function cardJS(p) {
    var saldo = p.pp && p.pp > p.p;
    var prezzo = saldo ? "<s>" + euro(p.pp) + "</s> <span class=\"prezzo--saldo\">" + euro(p.p) + "</span>" : "<span>" + euro(p.p) + "</span>";
    var esaurito = !p.a ? "<span class=\"capo__badge\">" + esc(testo("[data-t-esaurito]")) + "</span>" : "";
    return "<li class=\"capo\"><a class=\"capo__link\" href=\"" + esc(p.u) + "\">" +
      "<span class=\"capo__foto\" style=\"--fondo:" + esc(p.f) + "\"" + (p.i2 ? " data-foto2=\"" + esc(p.i2) + "\"" : "") + ">" +
      (p.i ? "<img src=\"" + esc(p.i) + "\" width=\"" + p.w + "\" height=\"" + p.hh + "\" loading=\"lazy\" decoding=\"async\" alt=\"\">" : "") + esaurito + "</span>" +
      "<span class=\"capo__marchio\">" + (p.m ? esc(p.m) : "&nbsp;") + "</span><span class=\"capo__titolo\">" + esc(p.t) + "</span>" +
      "<span class=\"capo__prezzo\">" + prezzo + "</span></a></li>";
  }
  /* le card entrano in fila (solo quelle nuove, al massimo 12 col ritardo) */
  function entrata(els) {
    if (calma.matches) return;
    els.forEach(function (el, k) {
      el.classList.remove("entra");
      void el.offsetWidth;
      el.style.setProperty("--k", Math.min(k, 12));
      el.classList.add("entra");
    });
  }
  /* al passaggio del mouse, la seconda foto (si carica solo allora) */
  if (win.matchMedia("(hover: hover)").matches) {
    doc.addEventListener("pointerover", function (e) {
      var f = e.target.closest && e.target.closest(".capo__foto[data-foto2]");
      if (!f || f.getAttribute("data-2")) return;
      f.setAttribute("data-2", "1");
      var im = new Image();
      im.className = "capo__img2";
      im.alt = "";
      im.decoding = "async";
      im.src = f.getAttribute("data-foto2");
      f.appendChild(im);
    });
  }

  /* ── pannelli: carrello, ricerca, filtri da telefono. Uno alla volta, col velo, Esc e il fuoco dentro ── */
  var velo = $("[data-velo]"), aperto = null, primaDi = null;
  var carrelloEl = $("#carrello");
  function apri(el, chi) {
    if (!el) return;
    if (aperto && aperto !== el) chiudi(true);
    if (body.classList.contains("menu-aperto")) { var mb = $(".menu-btn"); if (mb) mb.click(); }
    aperto = el;
    primaDi = chi || doc.activeElement;
    el.classList.add("is-open");
    if (el.hasAttribute("aria-hidden")) el.setAttribute("aria-hidden", "false");
    if (velo) velo.classList.add("is-on");
    body.classList.add("pannello-aperto");
    var f = $("[data-cerca-input]", el) || $("[data-chiudi]", el);
    win.setTimeout(function () { if (f) f.focus({ preventScroll: true }); }, 80);
  }
  function chiudi(subito) {
    if (!aperto) return;
    var el = aperto;
    aperto = null;
    el.classList.remove("is-open");
    if (el.hasAttribute("aria-hidden")) el.setAttribute("aria-hidden", "true");
    if (velo) velo.classList.remove("is-on");
    body.classList.remove("pannello-aperto");
    if (!subito && primaDi && primaDi.focus) primaDi.focus({ preventScroll: true });
  }
  function trappola(e) {
    var f = $$("a[href],button:not([disabled]),input:not([disabled]),select,summary,[tabindex]:not([tabindex='-1'])", aperto)
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && doc.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  doc.addEventListener("click", function (e) {
    if (aperto && e.target.closest("[data-apri-store]")) { chiudi(true); return; }   // «Guarda gli store»: la tendina la apre main.js
    var t = e.target.closest("[data-apri]");
    if (t) {
      var el = doc.getElementById(t.getAttribute("data-apri"));
      if (!el) return;
      e.preventDefault();
      if (aperto === el) { chiudi(); return; }
      if (el === carrelloEl) { disegnaCarrello(false); carica().then(function () { disegnaCarrello(false); }).catch(function () {}); }
      apri(el, t);
      return;
    }
    if (aperto && (e.target.closest("[data-chiudi]") || e.target.closest("[data-velo]"))) { e.preventDefault(); chiudi(); }
  });
  doc.addEventListener("keydown", function (e) {
    if (!aperto) return;
    if (e.key === "Escape") chiudi();
    else if (e.key === "Tab") trappola(e);
  });

  /* ── il carrello: quello di Shopify ───────────────────── */
  var cart = null;
  function carica() {
    return fetch(ROOT + "cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("cart " + r.status); return r.json(); })
      .then(function (c) { cart = c; aggiornaBorsa(); return c; });
  }
  function aggiornaBorsa(batti) {
    var n = cart ? cart.item_count : 0;
    $$("[data-borsa-n]").forEach(function (b) { b.textContent = n > 99 ? "99+" : String(n); b.hidden = !n; });
    $$(".borsa").forEach(function (b) {
      var et = b.getAttribute("data-etichetta") || "Carrello";
      b.setAttribute("aria-label", n ? et + " (" + n + ")" : et);
      if (batti) { b.classList.remove("is-batte"); void b.offsetWidth; b.classList.add("is-batte"); }
    });
  }
  function aggiungi(id) {
    return fetch(ROOT + "cart/add.js", { method: "POST", credentials: "same-origin", headers: JSON_H,
                                         body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error("add " + r.status); return r.json(); })
      .then(function () { return carica(); })
      .then(function () { aggiornaBorsa(true); });
  }
  function cambia(riga, q) {
    return fetch(ROOT + "cart/change.js", { method: "POST", credentials: "same-origin", headers: JSON_H,
                                            body: JSON.stringify({ line: riga, quantity: q }) })
      .then(function (r) { if (!r.ok) throw new Error("change " + r.status); return r.json(); })
      .then(function (c) { cart = c; aggiornaBorsa(); return c; });
  }
  function disegnaCarrello(avviso, fuoco) {
    if (!carrelloEl) return;
    var righe = $("[data-righe]", carrelloEl), vuoto = $("[data-carrello-vuoto]", carrelloEl), piede = $("[data-piede]", carrelloEl);
    $("[data-aggiunto]", carrelloEl).hidden = !avviso;
    var voci = cart ? cart.items : [];
    vuoto.hidden = !!voci.length;
    piede.hidden = !voci.length;
    if (!voci.length) { righe.innerHTML = ""; return; }
    var tRimuovi = testo("[data-t-rimuovi]") || "Rimuovi", tQuant = testo("[data-t-quantita]") || "Quantità";
    righe.innerHTML = voci.map(function (x, i) {
      var opz = (x.options_with_values || []).filter(function (o) { return o.value !== "Default Title"; })
        .map(function (o) { return esc(o.name) + " " + esc(o.value); }).join(" · ");
      var img = x.image ? x.image.replace(/(\.[a-z]+)(\?|$)/i, "$1$2") : "";
      return "<li class=\"riga-c\" data-i=\"" + i + "\" style=\"--k:" + Math.min(i, 8) + "\">" +
        "<a class=\"riga__foto\" href=\"" + esc(x.url) + "\" tabindex=\"-1\" aria-hidden=\"true\">" +
        (img ? "<img src=\"" + esc(img + (img.indexOf("?") < 0 ? "?" : "&") + "width=320") + "\" alt=\"\" loading=\"lazy\">" : "") + "</a>" +
        "<div class=\"riga__info\"><p class=\"riga__marchio\">" + esc(x.vendor === document.documentElement.getAttribute("data-nome-negozio") ? "" : x.vendor) + "</p>" +
        "<a class=\"riga__titolo\" href=\"" + esc(x.url) + "\">" + esc(x.product_title) + "</a>" +
        (opz ? "<p class=\"riga__taglia\">" + opz + "</p>" : "") +
        "<div class=\"riga__q\" role=\"group\" aria-label=\"" + esc(tQuant) + "\"><button type=\"button\" data-meno aria-label=\"Uno in meno\">−</button>" +
        "<span aria-live=\"polite\">" + x.quantity + "</span>" +
        "<button type=\"button\" data-piu aria-label=\"Uno in più\"" + (x.quantity >= 10 ? " disabled" : "") + ">+</button></div></div>" +
        "<div class=\"riga__dx\"><p class=\"riga__prezzo\">" + euro(x.final_line_price / 100) + "</p>" +
        "<button class=\"riga__togli\" type=\"button\" data-togli>" + esc(tRimuovi) + "</button></div></li>";
    }).join("");
    $("[data-totale]", carrelloEl).textContent = euro(cart.total_price / 100);
    if (fuoco) {
      var b = righe.querySelector(".riga-c[data-i=\"" + fuoco.i + "\"] [" + fuoco.a + "]") ||
              righe.querySelector(".riga-c [data-togli]") || $("[data-chiudi]", carrelloEl);
      if (b && !b.disabled) b.focus({ preventScroll: true }); else $("[data-chiudi]", carrelloEl).focus({ preventScroll: true });
    }
  }
  if (carrelloEl) {
    carrelloEl.addEventListener("click", function (e) {
      var li = e.target.closest(".riga-c");
      if (!li || !cart) return;
      var i = +li.getAttribute("data-i"), x = cart.items[i], q = null, azione = null;
      if (!x) return;
      if (e.target.closest("[data-piu]")) { q = Math.min(10, x.quantity + 1); azione = "data-piu"; }
      else if (e.target.closest("[data-meno]")) { q = x.quantity - 1; azione = q < 1 ? "data-togli" : "data-meno"; }
      else if (e.target.closest("[data-togli]")) { q = 0; azione = "data-togli"; }
      else return;
      $$("button", li).forEach(function (b) { b.disabled = true; });
      cambia(i + 1, Math.max(0, q)).then(function () {
        aggiornaBorsa(azione === "data-piu");
        disegnaCarrello(false, { i: i, a: azione });
      }).catch(function () { disegnaCarrello(false); });
    });
  }
  win.addEventListener("pageshow", function () { carica().catch(function () {}); });

  /* ── la ricerca: quella di Shopify, coi capi nella card del sito ── */
  var cercaEl = $("#cerca");
  if (cercaEl) {
    var input = $("[data-cerca-input]", cercaEl), ris = $("[data-cerca-risultati]", cercaEl);
    var vuotoC = $("[data-cerca-vuoto]", cercaEl), chips = $("[data-cerca-chips]", cercaEl), timer = null, ultima = "";
    var memo = {};
    var cerca = function () {
      var q = input.value.trim();
      if (piatto(q).length < 2) { ris.innerHTML = ""; vuotoC.hidden = true; chips.hidden = false; ultima = ""; return; }
      chips.hidden = true;
      var qq = q.replace(/\s+/g, " ");
      ultima = qq;
      var p = memo[qq] || (memo[qq] = fetch(ROOT + "search?type=product&options%5Bprefix%5D=last&view=qs-json&q=" + encodeURIComponent(qq), { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error("search " + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); }));
      p.then(function (l) {
        if (ultima !== qq) return;
        vuotoC.hidden = !!l.length;
        ris.innerHTML = l.map(cardJS).join("");
        entrata($$(".capo", ris));
      }).catch(function () { delete memo[qq]; });
    };
    input.addEventListener("input", function () { win.clearTimeout(timer); timer = win.setTimeout(cerca, 160); });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); win.clearTimeout(timer); cerca(); input.blur(); } });
    chips.addEventListener("click", function (e) {
      var a = e.target.closest("[data-cerca-chip]");
      if (!a) return;
      e.preventDefault();
      input.value = a.getAttribute("data-cerca-chip");
      cerca();
      input.focus();
    });
  }

  /* ── fisarmoniche dello store (descrizione, materiale; i filtri da telefono): morbide ── */
  function fisarmonica(d, corpoSel, soloTelefono) {
    var s = $("summary", d);
    if (!s) return;
    s.addEventListener("click", function (e) {
      var corpo = $(corpoSel, d);
      if (!corpo || calma.matches || !corpo.animate || (soloTelefono && computer.matches)) return;
      e.preventDefault();
      var apri = !d.open;
      if (d._anim) d._anim.cancel();
      if (apri) d.open = true;
      var h = corpo.scrollHeight;
      var a = corpo.animate(apri ? [{ height: "0px", opacity: 0 }, { height: h + "px", opacity: 1 }]
                                 : [{ height: h + "px", opacity: 1 }, { height: "0px", opacity: 0 }],
                            { duration: apri ? 380 : 260, easing: "cubic-bezier(.16,1,.3,1)" });
      d._anim = a;
      a.onfinish = function () { d._anim = null; if (!apri) d.open = false; };
    });
  }
  $$(".filtro").forEach(function (d) { fisarmonica(d, ".filtro__corpo", true); });
  $$(".dettaglio").forEach(function (d) { fisarmonica(d, ".dettaglio__corpo"); });
  /* da computer i filtri sono tendine: una aperta alla volta, si chiudono fuori o con Esc */
  var filtriD = $$(".filtro");
  filtriD.forEach(function (d) {
    d.addEventListener("toggle", function () {
      if (d.open && computer.matches) filtriD.forEach(function (x) { if (x !== d) x.open = false; });
    });
  });
  doc.addEventListener("click", function (e) {
    if (!computer.matches || e.target.closest(".filtro")) return;
    filtriD.forEach(function (x) { x.open = false; });
  });
  doc.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !computer.matches) return;
    var a = filtriD.filter(function (x) { return x.open; })[0];
    if (a) { a.open = false; $("summary", a).focus(); }
  });

  /* ── home: gli ultimi arrivi, una riga per store. Col dito scorrono; da computer, le frecce ── */
  $$("[data-riga]").forEach(function (r) {
    var ul = $("[data-scorri]", r), prec = $("[data-prec]", r), succ = $("[data-succ]", r);
    if (!ul) return;
    function segna() {
      if (prec) prec.disabled = ul.scrollLeft < 4;
      if (succ) succ.disabled = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 4;
    }
    function passo(d) {
      var li = ul.querySelector(".capo"), gap = parseFloat(getComputedStyle(ul).columnGap) || 0;
      var w = li ? li.getBoundingClientRect().width + gap : ul.clientWidth;
      var quanti = Math.max(1, Math.floor((ul.clientWidth - 2 * (parseFloat(getComputedStyle(ul).paddingLeft) || 0) + gap) / w));
      ul.scrollBy({ left: d * quanti * w, behavior: calma.matches ? "auto" : "smooth" });
    }
    if (prec) prec.addEventListener("click", function () { passo(-1); });
    if (succ) succ.addEventListener("click", function () { passo(1); });
    var attesa = false;
    ul.addEventListener("scroll", function () {
      if (attesa) return;
      attesa = true;
      win.requestAnimationFrame(function () { attesa = false; segna(); });
    }, { passive: true });
    win.addEventListener("resize", segna);
    segna();
  });

  /* ── i capi di uno store: Uomo/Donna, categoria (schede), taglia, marchio, prezzo, ordina; tutto nell'indirizzo ── */
  var neg = $("[data-negozio]");
  if (neg) (function () {
    var griglia = $("[data-griglia]", neg), form = $("[data-filtri]", neg), sel = $("[data-ordina]", neg);
    var filtriEl = $("#filtri"), attivi = $("[data-attivi]", neg), vuotoN = $("[data-vuoto]", neg);
    var altriBox = $("[data-altri-box]", neg);
    var MULTI = ["taglia", "marchio", "prezzo"];
    var PASSO = 24, mostrati = PASSO;
    /* i valori dei filtri tutti nella stessa forma (marchio e categoria come slug, la taglia com'è) */
    if (form) $$("input[name=\"marchio\"]", form).forEach(function (i) { i.value = norm(i.value); });
    $$("a[data-marchio]").forEach(function (a) { a.setAttribute("data-marchio", norm(a.getAttribute("data-marchio"))); });
    var tabG = $$("[data-gen]", neg), tabC = $$("[data-cat]", neg);
    tabC.forEach(function (a) { a.setAttribute("data-cat", norm(a.getAttribute("data-cat"))); });
    var info = $$(".capo", griglia).map(function (li) {
      return { el: li, g: li.getAttribute("data-g"), c: norm(li.getAttribute("data-c")), m: norm(li.getAttribute("data-m")),
               p: +li.getAttribute("data-p"), ov: +li.getAttribute("data-ov"),
               tg: li.getAttribute("data-tg") ? li.getAttribute("data-tg").split("|") : [] };
    });
    var generi = tabG.map(function (a) { return a.getAttribute("data-gen"); });
    var categorie = tabC.map(function (a) { return a.getAttribute("data-cat"); });
    var stato = leggiURL();

    function leggiURL() {
      var u = new URLSearchParams(win.location.search), s = {};
      MULTI.forEach(function (g) { var v = u.get(g); s[g] = v ? v.split(",").filter(Boolean) : []; });
      s.marchio = s.marchio.map(norm);
      s.genere = u.get("genere") || "";
      if (generi.indexOf(s.genere) < 0) s.genere = "";
      s.categoria = norm(u.get("categoria") || "");
      if (categorie.indexOf(s.categoria) < 0) s.categoria = "";
      s.ordina = u.get("ordina") || "novita";
      return s;
    }
    function scriviURL() {
      var u = new URLSearchParams();
      if (stato.genere) u.set("genere", stato.genere);
      if (stato.categoria) u.set("categoria", stato.categoria);
      MULTI.forEach(function (g) { if (stato[g].length) u.set(g, stato[g].join(",")); });
      if (stato.ordina !== "novita") u.set("ordina", stato.ordina);
      var s = u.toString().replace(/%2C/g, ",");
      history.replaceState(null, "", win.location.pathname + (s ? "?" + s : ""));
    }
    function vale(g, x, v) {
      switch (g) {
        case "marchio": return x.m === v;
        case "taglia": return x.tg.indexOf(v) >= 0;
        case "prezzo":
          var a = v.split("-"), lo = +a[0] || 0, hi = a[1] ? +a[1] : Infinity;
          return x.p >= lo && x.p < hi;
      }
      return false;
    }
    function passa(x, salta) {
      if (stato.genere && salta !== "genere" && x.g !== stato.genere) return false;
      if (stato.categoria && salta !== "categoria" && x.c !== stato.categoria) return false;
      for (var i = 0; i < MULTI.length; i++) {
        var g = MULTI[i];
        if (g === salta || !stato[g].length) continue;
        if (!stato[g].some(function (v) { return vale(g, x, v); })) return false;
      }
      return true;
    }
    function nomeDi(g, v) {
      var inp = form && form.querySelector("input[name=\"" + g + "\"][value=\"" + (win.CSS && CSS.escape ? CSS.escape(v) : v) + "\"]");
      var l = inp && inp.closest("label");
      return l ? l.querySelector("span").textContent : v;
    }

    function applica(nuovi) {
      var lista = info.filter(function (x) { return passa(x); });
      lista.sort(function (a, b) {
        if (stato.ordina === "prezzo-crescente") return a.p - b.p || a.ov - b.ov;
        if (stato.ordina === "prezzo-decrescente") return b.p - a.p || a.ov - b.ov;
        return a.ov - b.ov;
      });
      var dentro = new Set(lista), frag = doc.createDocumentFragment(), entrano = [], prima = nuovi || 0;
      lista.forEach(function (x, i) {
        var vis = i < mostrati;
        if (vis && (x.el.hidden || i >= prima) && nuovi !== false) entrano.push(x.el);
        x.el.hidden = !vis;
        frag.appendChild(x.el);
      });
      info.forEach(function (x) { if (!dentro.has(x)) { x.el.hidden = true; frag.appendChild(x.el); } });
      griglia.appendChild(frag);
      if (nuovi !== false) entrata(entrano.slice(0, 24));
      var n = lista.length;
      vuotoN.hidden = !!n || !info.length;
      altriBox.hidden = n <= mostrati;
      altriBox.style.setProperty("--fatto", n ? Math.min(1, mostrati / n).toFixed(3) : 0);
    }
    function disponibili() {
      /* le categorie: si vedono quelle che hanno capi per il genere scelto (le altre si nascondono) */
      tabC.forEach(function (a) {
        var c = a.getAttribute("data-cat");
        var ci = !c || info.some(function (x) { return x.c === c && (!stato.genere || x.g === stato.genere); });
        a.parentElement.hidden = !ci;
        a.setAttribute("aria-current", stato.categoria === c ? "true" : "false");
      });
      tabG.forEach(function (a) { a.setAttribute("aria-current", stato.genere === a.getAttribute("data-gen") ? "true" : "false"); });
      /* i filtri: una voce senza capi (con gli altri filtri) si spegne; nessun numero accanto */
      if (form) MULTI.forEach(function (g) {
        var box = form.querySelector("[data-gruppo=\"" + g + "\"]");
        if (!box) return;
        var base = info.filter(function (x) { return passa(x, g); });
        $$("input", box).forEach(function (inp) {
          var ci = base.some(function (x) { return vale(g, x, inp.value); });
          var lab = inp.closest("label");
          lab.classList.toggle("is-vuota", !ci && !inp.checked);
          inp.disabled = !ci && !inp.checked;
        });
        box.classList.toggle("is-attivo", stato[g].length > 0);
      });
    }
    function segnaForm() {
      if (form) $$("input", form).forEach(function (inp) { inp.checked = stato[inp.name] && stato[inp.name].indexOf(inp.value) >= 0; });
      if (sel) sel.value = stato.ordina;
      $$("a[data-marchio]").forEach(function (a) {
        var on = stato.marchio.indexOf(a.getAttribute("data-marchio")) >= 0;
        a.classList.toggle("is-attivo", on);
        a.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }
    function chipAttivi() {
      var html = "", n = 0;
      MULTI.forEach(function (g) {
        stato[g].forEach(function (v) {
          n++;
          html += "<button class=\"chip chip--x\" type=\"button\" data-via=\"" + esc(g) + "\" data-val=\"" + esc(v) + "\">" + esc(nomeDi(g, v)) + "</button>";
        });
      });
      var azzera = $("[data-azzera]", neg);
      if (n) html += "<button class=\"chip chip--azzera\" type=\"button\" data-azzera>" + esc(azzera ? azzera.textContent : "") + "</button>";
      attivi.innerHTML = html;
      attivi.hidden = !n;
      var nf = $("[data-nf]", neg);
      if (nf) { nf.textContent = n; nf.hidden = !n; }
    }
    function tutto(nuovi) {
      segnaForm();
      applica(nuovi);
      disponibili();
      chipAttivi();
    }
    function inVista(a, subito) {
      var ul = a && a.closest("ul");
      if (!ul || ul.scrollWidth <= ul.clientWidth) return;
      var x = a.parentElement.getBoundingClientRect().left - ul.getBoundingClientRect().left + ul.scrollLeft;
      var pad = parseFloat(getComputedStyle(ul).paddingLeft) || 0;
      ul.scrollTo({ left: Math.max(0, x - pad - 24), behavior: calma.matches || subito ? "auto" : "smooth" });
    }
    /* le schede delle categorie che non stanno in una riga sfumano a destra (finché non si arriva in fondo) */
    $$(".schede-tab", neg).forEach(function (nav) {
      var ul = $("ul", nav);
      var segna = function () { nav.classList.toggle("scorre", ul.scrollWidth > ul.clientWidth + 2 && ul.scrollLeft + ul.clientWidth < ul.scrollWidth - 4); };
      ul.addEventListener("scroll", segna, { passive: true });
      win.addEventListener("resize", segna);
      segna();
    });
    function cambia() {
      mostrati = PASSO;
      scriviURL();
      tutto(0);
      if (!filtriEl || !filtriEl.classList.contains("is-open")) {
        var top = neg.getBoundingClientRect().top + win.scrollY - 90;
        if (win.scrollY > top + 40) win.scrollTo({ top: top, behavior: calma.matches ? "auto" : "smooth" });
      }
    }

    if (form) form.addEventListener("change", function (e) {
      var inp = e.target;
      if (!inp.name || !stato[inp.name]) return;
      var l = stato[inp.name];
      var k = l.indexOf(inp.value);
      if (inp.checked && k < 0) l.push(inp.value);
      if (!inp.checked && k >= 0) l.splice(k, 1);
      cambia();
    });
    if (sel) sel.addEventListener("change", function () { stato.ordina = sel.value; cambia(); });
    neg.addEventListener("click", function (e) {
      var g = e.target.closest("[data-gen]");
      if (g) {
        e.preventDefault();
        stato.genere = g.getAttribute("data-gen");
        var c = stato.categoria;
        if (c && !info.some(function (x) { return x.c === c && (!stato.genere || x.g === stato.genere); })) stato.categoria = "";
        cambia();
        return;
      }
      var t = e.target.closest("[data-cat]");
      if (t) {
        e.preventDefault();
        stato.categoria = t.getAttribute("data-cat");
        cambia();
        inVista(t);
        return;
      }
      var via = e.target.closest("[data-via]");
      if (via) {
        var gr = via.getAttribute("data-via"), v = via.getAttribute("data-val");
        stato[gr] = stato[gr].filter(function (x) { return x !== v; });
        cambia();
        return;
      }
      if (e.target.closest("[data-azzera]")) {
        MULTI.forEach(function (x) { stato[x] = []; });
        cambia();
        return;
      }
      if (e.target.closest("[data-altri]")) {
        var prima = mostrati;
        mostrati += PASSO;
        applica(prima);
        var primo = info.filter(function (x) { return !x.el.hidden; })[prima];
        var a = primo && primo.el.querySelector("a");
        if (a) a.focus({ preventScroll: true });
      }
    });
    /* la fascia dei marchi (sopra i capi, nei multimarca): un logo filtra, e si scende ai capi */
    doc.addEventListener("click", function (e) {
      var m = e.target.closest("a[data-marchio]");
      if (!m) return;
      e.preventDefault();
      var s = m.getAttribute("data-marchio"), i = stato.marchio.indexOf(s);
      if (i >= 0) stato.marchio.splice(i, 1); else stato.marchio = [s];
      cambia();
      var top = neg.getBoundingClientRect().top + win.scrollY - 70;
      if (win.scrollY < top - 40) win.scrollTo({ top: top, behavior: calma.matches ? "auto" : "smooth" });
    });
    /* da computer i filtri sono tendine: se il pannello era aperto da telefono, si chiude */
    computer.addEventListener("change", function (q) { if (q.matches && aperto === filtriEl) chiudi(true); });
    win.addEventListener("popstate", function () { stato = leggiURL(); mostrati = PASSO; tutto(false); });

    tutto(false);
    var attiva = $("[data-cat][aria-current=\"true\"]", neg);
    if (attiva && attiva.getAttribute("data-cat")) inVista(attiva, true);
    neg.classList.add("pronto");
  })();

  /* ── la scheda prodotto: galleria, colore e taglia (la variante di Shopify), «Aggiungi al carrello» ── */
  var scheda = $("[data-scheda]");
  if (scheda) (function () {
    var gal = $("[data-galleria]", scheda);
    if (gal) {
      var traccia = $("[data-traccia]", gal), foto = $$(".galleria__foto", traccia), mini = $$(".galleria__mini", gal);
      var punti = $$(".galleria__punti span", gal), prec = $("[data-prec]", gal), succ = $("[data-succ]", gal), ora = -1;
      var segna = function (i) {
        if (i === ora) return;
        ora = i;
        mini.forEach(function (m, k) { m.classList.toggle("is-attiva", k === i); m.setAttribute("aria-current", k === i ? "true" : "false"); });
        punti.forEach(function (p, k) { p.classList.toggle("is-attivo", k === i); });
        if (prec) prec.disabled = i <= 0;
        if (succ) succ.disabled = i >= foto.length - 1;
      };
      var vai = function (i) {
        i = Math.max(0, Math.min(foto.length - 1, i));
        traccia.scrollTo({ left: i * traccia.clientWidth, behavior: calma.matches ? "auto" : "smooth" });
        segna(i);
      };
      var attesa = false;
      traccia.addEventListener("scroll", function () {
        if (attesa) return;
        attesa = true;
        win.requestAnimationFrame(function () {
          attesa = false;
          segna(Math.round(traccia.scrollLeft / Math.max(1, traccia.clientWidth)));
        });
      }, { passive: true });
      mini.forEach(function (m, k) { m.addEventListener("click", function () { vai(k); }); });
      if (prec) prec.addEventListener("click", function () { vai(ora - 1); });
      if (succ) succ.addEventListener("click", function () { vai(ora + 1); });
      traccia.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") { e.preventDefault(); vai(ora + 1); }
        if (e.key === "ArrowLeft") { e.preventDefault(); vai(ora - 1); }
      });
      segna(0);
    }

    var form = $("[data-scheda-form]", scheda), fs = $("[data-taglie]", scheda), fc = $("[data-colori]", scheda);
    if (!form) return;
    var V = { t: -1, c: -1, v: [] };
    try { V = JSON.parse($("[data-varianti]", form).textContent); } catch (e) {}
    var idEl = $("[data-variante]", form), prezzoEl = $("[data-prezzo]", scheda), nomeCol = $("[data-colore-nome]", scheda);
    var tEsaurito = $(".scheda__aggiungi", form) ? testo("[data-t-esaurito]") : "";
    function scelta(n) { var x = form.querySelector("input[name=\"" + n + "\"]:checked"); return x ? x.value : null; }
    function varianteDi(t, c) {
      return V.v.filter(function (x) {
        return (V.t < 0 || t == null || x.o[V.t] === t) && (V.c < 0 || c == null || x.o[V.c] === c);
      });
    }
    function aggiornaScelte() {
      var c = scelta("colore");
      if (nomeCol && c) nomeCol.textContent = c;
      /* col colore scelto, le taglie che per quel colore non ci sono si spengono */
      if (fs && V.c >= 0 && c != null) {
        $$("input[name=\"taglia\"]", fs).forEach(function (inp) {
          var ok = V.v.some(function (x) { return x.o[V.t] === inp.value && x.o[V.c] === c && x.a; });
          inp.disabled = !ok;
          if (!ok && inp.checked) inp.checked = false;
          var lab = inp.closest("label");
          lab.classList.toggle("taglia--no", !ok);
          if (ok) lab.removeAttribute("title"); else lab.setAttribute("title", tEsaurito);
        });
      }
      var l = varianteDi(scelta("taglia"), c).filter(function (x) { return x.a; });
      var v = (scelta("taglia") != null || V.t < 0) ? l[0] : null;
      if (v) {
        idEl.value = v.id;
        if (prezzoEl) prezzoEl.innerHTML = v.pp && v.pp > v.p
          ? "<s>" + euro(v.pp / 100) + "</s> <span class=\"prezzo--saldo\">" + euro(v.p / 100) + "</span>"
          : "<span>" + euro(v.p / 100) + "</span>";
      }
      return v;
    }
    var voce = doc.createElement("span");
    voce.className = "sr-only";
    voce.setAttribute("aria-live", "assertive");
    form.appendChild(voce);
    form.addEventListener("change", function (e) {
      if (e.target.name === "colore" || e.target.name === "taglia") aggiornaScelte();
      if (fs) { fs.classList.remove("is-errore"); voce.textContent = ""; }
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = $(".scheda__aggiungi", form);
      if (!btn || btn.disabled) return;
      var scelto = form.querySelector("input[name=\"taglia\"]:checked");
      if (fs && !scelto) {
        fs.classList.remove("is-errore");
        void fs.offsetWidth;
        fs.classList.add("is-errore");
        voce.textContent = "";
        win.setTimeout(function () { voce.textContent = $(".taglie__legenda", fs).textContent; }, 30);
        var primo = fs.querySelector("input:not([disabled])");
        if (primo) primo.focus({ preventScroll: true });
        if (primo && primo.getBoundingClientRect().top < 80) fs.scrollIntoView({ block: "center", behavior: calma.matches ? "auto" : "smooth" });
        return;
      }
      var v = aggiornaScelte();
      var id = v ? v.id : idEl.value;
      btn.disabled = true;
      aggiungi(id).then(function () {
        btn.disabled = false;
        disegnaCarrello(true);
        apri(carrelloEl, btn);
      }).catch(function () { btn.disabled = false; form.submit(); });
    });
    aggiornaScelte();
  })();

  carica().catch(function () {});
})();
